/* eslint-disable max-len */
import { Theme, StyleRules } from '@material-ui/core/styles';

const styles = (theme: Theme): StyleRules => ({
  root: {
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.common.backgroundMuted
        : theme.palette.common.white,
    color:
      theme.palette.type === 'dark'
        ? theme.palette.common.tan
        : theme.palette.common.midBlue,
    maxWidth: 1000,
    margin: '0 auto',
    borderRadius: 12,
    fontFamily: theme.typography.fontFamily,
    boxShadow:
      theme.palette.type === 'light'
        ? `0 0 8px 0 ${theme.palette.common.greyBorder}`
        : 'none!important',

    '& .GridItemContentCenter': {
      margin: '0 auto',
      [theme.breakpoints.down('sm')]: {
        textAlign: 'center',
        justifyContent: 'center',
      },
    },
  },

  helpTitleContainer: {
    display: 'flex',
    alignContent: 'center',
    gap: 10,
    padding: '30px 60px 0',
    borderBottom:
      theme.palette.type === 'dark'
        ? `1px solid ${theme.palette.common.greyBorder}`
        : `1px solid ${theme.palette.common.greyLight}`,

    [theme.breakpoints.down('sm')]: {
      padding: '26px 18px 0',
    },
  },
  helpContainer: {
    padding: '30px 60px',

    [theme.breakpoints.down('sm')]: {
      padding: '26px 18px',
    },
  },

  helpContentGrid: {
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
  helpContentGridItem: {
    width: '50%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  helpContentGridItemBorder: {
    borderRight: `1px solid ${theme.palette.common.backgroundDark}`,
    [theme.breakpoints.down('sm')]: {
      borderRight: 'none',
    },
  },
  personGrid: {
    display: 'flex',
    gap: 30,
    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
  imageBoxContainer: {},
  imageBox: {
    position: 'relative',
    width: 100,
    height: 100,
    [theme.breakpoints.down('sm')]: {
      width: 100,
      height: 100,
      margin: '0 auto 10px',
    },
    '& svg': {
      position: 'absolute',
      bottom: 0,
      left: 0,
      '& circle': {
        fill: theme.palette.common.tan,
      },
    },
    '& img': {
      position: 'absolute',
      width: 100,
      height: 100,
      bottom: 0,
      left: 0,
      maskSize: 'contain',
      maskRepeat: 'no-repeat',
      maskPosition: 'bottom center',
      maskImage:
        "url(\"data:image/svg+xml,%3c%3fxml version='1.0' encoding='utf-8'%3f%3e %3csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 1000 1100' style='enable-background:new 0 0 1000 1100%3b' xml:space='preserve'%3e %3cstyle type='text/css'%3e .st0%7bfill:black%3b%7d %3c/style%3e %3cg%3e %3cpath class='st0' d='M0.5%2c0v600c0%2c276.1%2c223.9%2c500%2c500%2c500s500-223.9%2c500-500V0H0.5z'/%3e %3c/g%3e %3c/svg%3e\")",
    },
  },
  content: {},

  helpTitle: {
    fontSize: 24,
    lineHeight: '32px',
    marginBottom: 32,
    fontWeight: 600,

    [theme.breakpoints.down('sm')]: {
      fontSize: 22,
      lineHeight: '29px',
    },
  },

  name: {
    color: (theme.palette.type === 'light' && theme.palette.common.midBlue) as
      | string
      | undefined,
    margin: '0 0 15px 0',
    fontSize: 18,
    fontWeight: 500,

    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
      fontSize: 16,
    },
  },
  contactNum: {
    display: 'flex',
    gap: 10,
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
      fontSize: 14,
    },
    marginBottom: 10,
    '& a': {
      display: 'block',
      textDecoration: 'none',
      color:
        theme.palette.type === 'dark'
          ? theme.palette.common.tan
          : theme.palette.common.midBlue,
      '&.active, &:focus, &:hover': {
        textDecoration: 'none',
      },
    },
  },
  workPhone: {
    backgroundSize: '18px 18px!important',
    width: '18px!important',
    height: '18px!important',
    '& a': {
      textDecoration: 'none',
      color:
        theme.palette.type === 'dark'
          ? theme.palette.common.tan
          : theme.palette.common.midBlue,
    },
  },
  mobilePhone: {
    backgroundSize: '18px 18px!important',
    width: '18px!important',
    height: '18px!important',
    '& a': {
      textDecoration: 'none',
      color:
        theme.palette.type === 'dark'
          ? theme.palette.common.tan
          : theme.palette.common.midBlue,
    },
  },
  emailLink: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
      justifyContent: 'center',
      fontSize: 14,
    },
    marginBottom: 10,
    '& a': {
      display: 'block',
      color: theme.palette.common.coral,
      textDecoration: 'none',
      '&.active, &:focus, &:hover': {
        textDecoration: 'none',
      },
    },
  },
  button: {
    backgroundColor: (theme.palette.type === 'light' &&
      theme.palette.common.white) as string | undefined,
    width: 280,
    maxWidth: 280,
    color:
      theme.palette.type === 'dark'
        ? theme.palette.common.white
        : theme.palette.common.midBlue,
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },

    '& a': {
      textDecoration: 'none',
      color:
        theme.palette.type === 'dark'
          ? theme.palette.common.white
          : theme.palette.common.midBlue,
    },
    '&:hover a': {
      color:
        theme.palette.type === 'dark'
          ? theme.palette.common.white
          : theme.palette.common.white,
    },
  },
});

export default styles;
